<script setup lang="ts">
	import {
		Chart as ChartJS,
		Tooltip,
		BarElement,
		CategoryScale,
		LinearScale,
		type ChartData,
		type ChartOptions
	} from 'chart.js'
	import { Bar } from 'vue-chartjs'
	import { merge } from '@/utils/merge'

	const props = defineProps<{
		data: ChartData<'bar'>
		options?: ChartOptions<'bar'>
	}>()

	const defaultOptions: ChartOptions<'bar'> = {
		responsive: true,
		plugins: {
			legend: {
				display: false
			}
		},
		scales: {
			x: {
				grid: { display: false },
				beginAtZero: false,
				ticks: {
					color: '#475467',
					font: { family: 'Metropolis', size: 10 }
				},
				border: {
					display: false
				}
			},
			y: {
				beginAtZero: false,
				grid: {
					color: '#E3E6ED'
				},
				ticks: {
					color: '#98A2B3',
					font: { family: 'Metropolis', size: 12 },
					align: 'center'
				},
				border: {
					display: false
				},
				// max: 200
				min: 0
			}
		}
	}

	const mergedOptions = computed<ChartOptions<'bar'>>(() => {
		return merge(defaultOptions, props?.options ?? {})
	})
	onActivated(() => {
		ChartJS.unregister()
	})
	onBeforeMount(() => {
		ChartJS.register(LinearScale, BarElement, Tooltip, CategoryScale)
	})
</script>

<template>
	<Bar class="h-full" :data="data" :options="mergedOptions" />
</template>
